import { render, staticRenderFns } from "./TransactionTicket.vue?vue&type=template&id=3a50d986&scoped=true&"
import script from "./TransactionTicket.vue?vue&type=script&lang=js&"
export * from "./TransactionTicket.vue?vue&type=script&lang=js&"
import style0 from "./TransactionTicket.vue?vue&type=style&index=0&lang=less&"
import style1 from "./TransactionTicket.vue?vue&type=style&index=1&id=3a50d986&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a50d986",
  null
  
)

export default component.exports